import {BaseCardData, CardClickPopupType} from '@colonist/game-card-types'
import {CardEnum, CardTypeEnum} from '@colonist/game-states'

export function getAnyResourceCardData(): BaseCardData[] {
    return [
        {
            cardEnum: CardEnum.AnyResource,
            cardTypeEnum: CardTypeEnum.AnyResource,
            isCardBack: false,
            clickPopupType: CardClickPopupType.None,
            allowableTurnStates: undefined,
        },
    ]
}
